import type {BulkOperationResponseBody} from '../types/api/bulkOperations';

export function getBulkOperationProcessedCount(
  operation: Pick<BulkOperationResponseBody, 'doneCount' | 'failedCount' | 'skippedCount'>
) {
  return operation.doneCount + operation.failedCount + operation.skippedCount;
}
